{
  "module_key": "protex",
  "area_key": "nucleus",
  "display_name": "Protex",
  "kind": "native",
  "api_base": "https://os.ketosource.co/protex/v1",
  "permission_scopes": [
    "nucleus"
  ],
  "tabs": [
    {
      "tab_key": "facts",
      "display_name": "Facts",
      "tab_order": 1,
      "permission_scope": "nucleus"
    },
    {
      "tab_key": "audit",
      "display_name": "Audit",
      "tab_order": 2,
      "permission_scope": "nucleus"
    },
    {
      "tab_key": "inbox",
      "display_name": "Inbox",
      "tab_order": 3,
      "permission_scope": "nucleus",
      "min_level": "view"
    }
  ],
  "owner_email": "damien@ketosource.co",
  "help_url": "mailto:damien@ketosource.co"
}
